module.exports = __webpack_public_path__ + "logout.svg?1793698113381";